export const scrollIntoView = (element: HTMLElement, offset?: number) => {
  const yOffset = offset === undefined ? 60 : offset;
  const y = element.getBoundingClientRect().top + window.scrollY - yOffset;
  window.scrollTo({ top: y, behavior: "smooth" });
};
